export default __webpack_public_path__ + "static/media/eretria-big-logo.1394caa9.png";